
/****
 *    Function : displayPublicationListingFn
 *    Usage : handling the display mode of the publications
 ****/
export function displayPublicationListingFn () {
  const buttons = document.querySelectorAll('[data-display]');
  const wrapper = document.querySelector('.mosaic,.lines');

  Object.values(buttons).map(button => {
    //On click we trigger the display mode associated
    button.addEventListener('click', () => {
      activateDisplay(button.dataset.display, button, wrapper);
    });
  });

  //Storing the preferred data display mode in the Local Storage
  if (localStorage.getItem('display_publications')) {
    document.querySelector(`[data-display="${localStorage.getItem('display_publications')}"]`)?.click();
  }
};

function activateDisplay (display, button, wrapper) {
  const active = document.querySelector('[data-display].active');
  const publications = document.querySelector('.publications--listing');

  publications.style.opacity = 0;
  active.classList.remove('active');
  button.classList.add('active');

  wrapper.classList.remove('mosaic', 'lines');
  wrapper.classList.add(display);
  localStorage.setItem('display_publications', display);
  publications.style.opacity = 1;

}
